import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `cambioEstadoVerraco/checkCambioEstadoFecha`, method: 'POST', body: values, token: token})
}
